import produce from 'immer';
import { NEWS } from "../actionTypes";

const initialState = {
    announcementsSectors: [],
    newsTypes: [],
    newsSector: [],
    activeNewsType: {},
    newsDetails: [],
    hotPursuitData: [],
    otherNews: [],
    FIIArray: [],
    DIIArray: [],
    MFArray: [],
    arrAgRowData: [],
    arrHotPursuitData: [],
    arrNewsData: [],
    arrAnnouncement: [],
    isLimtReached: false,
    holdingNews: [],
    activeNewsTab: 1,
    sectorCode: "",
    announcementType: "",
    newsSearchText: '',
    isRequestFailed: false,
    isAnnouncementAPIFailed: false,
    isHotPursuitAPIFailed: false,
    isNewsAPIFailed: false,
    nAnnouncementStatus: '',
    //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – Start 
    bIsAnnouncementAPIPending: false,
    bIsHotPursuitAPIPending: false,
    bIsNewsAPIPending: false,
    bIsSectorWiseNewsDetailsApiPending: false,
    objReduxNewsScrips: {}
    //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – End 
};


const newsReducer = (state = initialState, actions) => {

    switch (actions.type) {
        case NEWS.UPDATE_VISBLE_SCRIP_FOR_SUB_AND_UNSUB: {
            return {
                ...state,
                objReduxNewsScrips: actions?.payload
            };
        }
        case NEWS.GET_EXCHANGE_ANNOUNCEMENTS_SUCCESS: {
            return produce(state, draftState => {
                draftState.arrAnnouncement.push(...actions.payload);
                draftState.isAnnouncementAPIFailed = false;
            });
        }
        case NEWS.UPDATE_ANNOUNCEMENT_STATUS: {
            return {
                ...state,
                nAnnouncementStatus: actions.payload
            };
        }
        case NEWS.UPDATE_ACTIVE_TAB: {
            return {
                ...state,
                isRequestFailed: false,
                activeNewsTab: actions.payload
            };
        }
        case NEWS.UPDATE_NEWS_SEARCH_TEXT: {
            return {
                ...state,
                newsSearchText: actions.payload
            };
        }
        case NEWS.UPDATE_NEWS_SECTOR: {
            return {
                ...state,
                sectorCode: actions.payload
            };
        }
        case NEWS.UPDATE_ANNOUNCEMENT_TYPE: {
            return {
                ...state,
                isRequestFailed: false,
                announcementType: actions.payload
            };
        }
        case NEWS.GET_EXCHANGE_ANNOUNCEMENTS_FAILURE: {
            return {
                ...state,
                isAnnouncementAPIFailed: true
            };
        }
        case NEWS.CLEAR_ANNOUNCEMENT_STATE: {
            return {
                ...state,
                isLimtReached: false,
                isAnnouncementAPIFailed: false,
                arrAnnouncement: [],
            };
        }

        case NEWS.CLEAR_NEWS_DETAIL_STATES: {
            return {
                ...state,
                hotPursuitData: [],
                otherNews: [],
                newsDetails: []
            };
        }
        case NEWS.UPDATE_ACTIVE_NEWS: {
            return {
                ...state,
                activeNewsType: actions.payload
            };
        }
        case NEWS.GET_NEWS_SECTORS_SUCCESS: {
            return {
                ...state,
                newsSector: actions.payload,
            };
        }
        case NEWS.GET_NEWS_SECTORS_FAILURE: {
            return {
                ...state,
                errorMessage: actions.payload,
            };
        }
        case NEWS.GET_SECTOR_WISE_NEWS_SUCCESS: {
            return produce(state, draftState => {
                draftState.arrNewsData.push(...actions.payload);
                draftState.isNewsAPIFailed = false;
            });
        }
        case NEWS.GET_SECTOR_WISE_NEWS_FAILURE: {
            return {
                ...state,
                isNewsAPIFailed: true
            };
        }
        case NEWS.GET_HOLDINGS_NES_SUCCESS: {
            return {
                ...state,
                holdingNews: actions.payload
            };
        }
        case NEWS.IS_REACHED_LIMIT: {
            return {
                ...state,
                isLimtReached: true
            };
        }
        case NEWS.CLEAR_NEWS_STATE: {
            return {
                ...state,
                isLimtReached: false,
                isRequestFailed: false,
                arrNewsData: []
            };
        }
        case NEWS.GET_HOT_PURSUIT_NEWS_SUCCESS: {

            return {
                ...state,
                isHotPursuitAPIFailed: false,
                arrHotPursuitData: actions.payload
            };
        }
        case NEWS.GET_HOT_PURSUIT_NEWS_FAILURE: {
            return {
                ...state,
                isHotPursuitAPIFailed: true,
                arrHotPursuitData: actions.payload,
            };
        }
        case NEWS.GET_SECTOR_WISE_NEWS_DETAILS_SUCCESS: {
            return {
                ...state,
                isRequestFailed: false,
                newsDetails: actions.payload
            };
        }
        case NEWS.GET_SECTOR_WISE_NEWS_DETAILS_FAILURE: {
            return {
                ...state,
                isRequestFailed: true,
                newsDetails: []
            };
        }

        case NEWS.GET_HOT_PURSUIT_DETAILS_SUCCESS: {
            return { ...state, isRequestFailed: false, hotPursuitData: actions.payload };
        }
        case NEWS.GET_HOT_PURSUIT_DETAILS_FAILURE: {
            return { ...state, isRequestFailed: true, hotPursuitData: [] };
        }
        case NEWS.GET_OTHER_NEWS_DATA: {
            return { ...state, otherNews: actions.payload };
        }
        case NEWS.GET_MERGER_DEMERGER_SUCCESS: {
            return { ...state, arrAgRowData: actions.payload };
        }
        case NEWS.GET_MERGER_DEMERGER_FAILURE: {
            return { ...state, arrAgRowData: [] };
        }
        case NEWS.GET_BULK_BLOCK_DEAL_SUCCESS: {
            return { ...state, arrAgRowData: actions.payload };
        }
        case NEWS.GET_BULK_BLOCK_DEAL_FAILURE: {
            return { ...state, arrAgRowData: [] };
        }
        case NEWS.GET_FII_SUCCESS: {
            return { ...state, FIIArray: actions.payload };
        }
        case NEWS.GET_FII_FAILURE: {
            return { ...state, FIIArray: [] };
        }
        case NEWS.GET_DII_SUCCESS: {
            return { ...state, DIIArray: actions.payload };
        }
        case NEWS.GET_DII_FAILURE: {
            return { ...state, DIIArray: [] };
        }
        case NEWS.GET_MF_SUCCESS: {
            return { ...state, MFArray: actions.payload };
        }
        case NEWS.GET_MF_FAILURE: {
            return { ...state, MFArray: [] };
        }
        //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – Start 
        case NEWS.IS_NEWS_API_PENDING: {
            return { ...state, bIsNewsAPIPending: actions.payload };
        }
        case NEWS.IS_HOTPURSSUIT_API_PENDING: {
            return { ...state, bIsHotPursuitAPIPending: actions.payload };
        }
        case NEWS.IS_ANNOUNCEMENT_API_PENDING: {
            return { ...state, bIsAnnouncementAPIPending: actions.payload };
        }
        case NEWS.IS_SECTORWISE_NEWS_DETAILS_API_PENDING: {
            return { ...state, bIsSectorWiseNewsDetailsApiPending: actions.payload };
        }
        //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – End 
        default:
            return state;
    }

};

export default newsReducer;
